import { z } from 'zod/v4';
export var ProductService;
(function (ProductService) {
    ProductService["Collection"] = "COLLECTION";
    ProductService["CourtHandling"] = "COURT_HANDLING";
})(ProductService || (ProductService = {}));
export const CreateConnectProductSchema = z.object({
    partnerId: z.uuid(),
    public: z.boolean().optional(),
    name: z.string(),
    logo: z.uuid().optional(),
    description: z.string(),
    content: z.string(),
    billingModelId: z.uuid().nullish(),
    workflowId: z.uuid().nullish(),
    caseGroupId: z.uuid().nullish(),
    service: z.enum(ProductService),
});
//# sourceMappingURL=index.js.map